<template>
  <div v-if="levelIsValid" class="climate-action-tracker">
    <EHeading as="h3" class="climate-action-tracker__heading">
      {{ $t("web.entities.climateactiontracker.header") }}
    </EHeading>
    <p class="climate-action-tracker__subheading">
      {{ entityName }}
    </p>
    <EImpactScale :level="level" @click="onLinkClick" />
    <p class="climate-action-tracker__level">
      <span class="climate-action-tracker-level__name">{{ levelName }}:</span>
      <span class="climate-action-tracker-level__description">{{ levelDescription }}</span>
      <ELink
        v-if="url"
        as="a"
        color="result"
        :href="url"
        target="_blank"
        rel="noopener"
        data-test-id="climate-action-tracker-level-link"
        @click="onLinkClick"
      >
        {{ $t("web.entities.readMore") }}
      </ELink>
    </p>
  </div>
</template>
<script>
import EHeading from '~~/common/vue/components/heading';
import ELink from '~~/common/vue/components/link';
import { trackClick, trackImpression, PAGE_SERP, TYPE_ENTITY } from '~~/search/common/js/client/analytics/rich-content';
import EImpactScale from './impact-scale';

const levels = ['CRITICALLY_INSUFFICIENT', 'HIGHLY_INSUFFICIENT', 'INSUFFICIENT',
  'ALMOST_SUFFICIENT', 'PARIS_COMPATIBLE', 'ROLE_MODEL'];

export const TRACK_ID = 'climate_action';

export default {
  components: {
    EHeading,
    ELink,
    EImpactScale,
  },
  props: {
    entityName: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      required: true,
      validator: (type) => levels.includes(type),
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    levelName() {
      return this.getLevelTranslation('name');
    },
    levelDescription() {
      return this.getLevelTranslation('description');
    },
    levelIsValid() {
      return levels.includes(this.level);
    },
  },
  mounted() {
    trackImpression({
      name: TRACK_ID,
      page: PAGE_SERP,
      type: TYPE_ENTITY,
      once: true,
    });
  },
  methods: {
    getLevelTranslation(type) {
      const levelName = this.level.replace('_', '').toLowerCase();
      return this.$t(`web.entities.climateactiontracker.level${type}.${levelName}`);
    },
    onLinkClick: trackClick({
      name: TRACK_ID,
      type: TYPE_ENTITY,
      target: 'link',
    }),
  },
};
</script>
<style lang="scss" scoped>
.climate-action-tracker {
  @include divider(top);

  margin-top: $space-1l;
  padding: $space-m 0 $space-1s;
}

.climate-action-tracker__heading {
  font-weight: $font-weight-m;
}

.climate-action-tracker__subheading {
  margin-top: 0;
  color: var(--color-text-secondary);
}

.climate-action-tracker__level {
  margin-bottom: 0;
}

.climate-action-tracker-level__name {
  font-weight: $font-weight-1l;
}
</style>
